import React, { useState } from 'react';
import { InformationTransparency, SourceRead, InformationTransparencyUpdatePayload, TransparencyClass } from '../../../../../api/apiTypes';
import { ConfirmValidationDialog } from '../../../../../utils/dialog/ConfirmValidationDialog';
import { cleanContent } from '../../../../../utils/cleanContent';
import Swal from 'sweetalert2';
import { updateTrasparenza, validaTrasparenza } from '../../../../../api/functionApi';
import { formatTitle } from '../../../../../utils/Format';
import { useAxiosInterceptor } from '../../../../../api/wrappers';
import EventList from '../../../../../utils/EventList';
import SourcesAccordion from '../../../../../components/report/SourcesAccordion';

type ContainerListaDriverPageProps = {
    intermediario: InformationTransparency;
    title: string;
    id: string;
    driverId: string;
    intermediarioId: string;
    sources: SourceRead[];
    events: any[];
};

// Definisci la stessa struttura dati che usi nell'altro componente
const transparencyClassesLegend = [
    {
        key: "strategy_with_fee_breakdown",
        label: "Fee breakdown",
        description: "Strategia pubblicata con suddivisione delle commissioni tra Banca trasmettitrice e Intermediario negoziatore"
    },
    {
        key: "strategy_with_total_costs",
        label: "Costi totali",
        description: "Strategia pubblicata con i costi complessivi senza suddivisione tra Banca trasmettitrice e Intermediario"
    },
    {
        key: "strategy_without_costs",
        label: "Senza costi",
        description: "Strategia pubblicata senza alcuna indicazione di costi"
    },
    {
        key: "no_strategy",
        label: "Nessuna strategia",
        description: "Nessuna strategia pubblicata"
    }
];

const ContainerTrasparenzaInformativaDettagli = ({
    intermediario,
    title,
    id,
    driverId,
    intermediarioId,
    sources, 
    events
}: ContainerListaDriverPageProps) => {

    const formattedTitle = formatTitle(title);
    useAxiosInterceptor(); // <--- monta l'interceptor

    const [values, setValues] = useState({
        transparency_class: intermediario.value.transparency_class ?? null,
     //  doc_update_date: intermediario.value.doc_update_date ?? null,
     //  score: intermediario.value.score,
     //  summary_selected_information: intermediario.value.summary_selected_information ?? '',
     //  list_relevant_sentences: intermediario.value.list_relevant_sentences ?? [],
     //  reasoning: intermediario.value.reasoning ?? '',
    });

    const [isEditing, setIsEditing] = useState(false);
    const [showDialogConfermaValidazione, setShowDialogConfermaValidazione] = useState(false);
    const [isIntermediarioValidato, setIsIntermediarioValidato] = useState(false);

    // Usa solo le chiavi per il mapping nel form principale
    const transparencyClasses = [
        "strategy_with_fee_breakdown",
        "strategy_with_total_costs",
        "strategy_without_costs",
        "no_strategy"
    ];

    if (!intermediario) {
        return (
            <div className="flex items-center justify-center h-screen">
                <div className="w-20 h-20 border-[6px] border-gray-300 border-t-textPrimary rounded-full animate-spin" />
            </div>
        );
    }

    const handleTransparencyClassChange = (newClass: string) => {
        if (isEditing) {
            setValues(prev => ({
                ...prev,
                transparency_class: newClass as TransparencyClass,
            }));
        }
    };

    const handleModifica = () => setIsEditing(true);

    const handleAnnulla = () => {
        setValues({
            transparency_class: intermediario.value.transparency_class ?? null,
       //     doc_update_date: intermediario.value.doc_update_date ?? null,
         //  score: intermediario.value.score,
         //  summary_selected_information: intermediario.value.summary_selected_information ?? '',
         //  list_relevant_sentences: intermediario.value.list_relevant_sentences ?? [],
         //  reasoning: intermediario.value.reasoning ?? '',
        });
        setIsEditing(false);
    };

    const handleSalva = async () => {
        const payload: InformationTransparencyUpdatePayload = {
            value: values,
        };

        try {
            await updateTrasparenza(id, driverId, intermediarioId, payload);
            setIsEditing(false);
setIsIntermediarioValidato(false);
            Swal.fire({
                icon: 'success',
                title: 'Modifica salvata!',
                text: 'Le modifiche sono state salvate correttamente.',
                confirmButtonColor: '#374151',
            });
        } catch (error) {
            console.error('Errore durante il salvataggio:', error);

            Swal.fire({
                icon: 'error',
                title: 'Errore nel salvataggio',
                text: 'Si è verificato un errore durante il salvataggio delle modifiche.',
                confirmButtonColor: '#374151',
            });
        }
    };

    const onClickValida = () => setShowDialogConfermaValidazione(true);

const handleValidazione = async () => {
    setShowDialogConfermaValidazione(false);

    // Mostra Swal di caricamento
    Swal.fire({
        title: 'Validazione in corso...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });

    try {
        await validaTrasparenza(id, driverId, intermediarioId);
        setIsIntermediarioValidato(true);

        Swal.fire({
            icon: 'success',
            title: 'Validato!',
            text: 'L\'intermediario è stato validato con successo.',
            confirmButtonColor: '#374151',
        });
    } catch (error) {
        console.error('Errore durante la validazione:', error);

        Swal.fire({
            icon: 'error',
            title: 'Errore nella validazione',
            text: 'Si è verificato un errore durante la validazione dell\'intermediario.',
            confirmButtonColor: '#374151',
        });
    }
};


    return (
        <div className="bg-white rounded-xl border border-gray-200 p-8">
            <h1 className="text-4xl font-bold text-[#1B365D] mb-8">{formattedTitle}</h1>
            <div className="flex justify-between items-center mb-8">
                <h1 className="text-3xl font-bold text-[#1B365D]">{intermediario.name}</h1>
                <span className="font-medium text-gray-600 text-sm">Score: {intermediario.value.score.total_score}</span>
            </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 mb-8">
                {transparencyClasses.map((className) => (
                    <div key={className}>
                        <label className="block text-sm font-medium text-gray-600 mb-1">
                            {className.replace(/_/g, ' ').toUpperCase()}
                        </label>
                        <input
                            type="text"
                            value={values.transparency_class === className ? 'V' : ''}
                            readOnly={!isEditing}
                            onClick={() => handleTransparencyClassChange(className)}
                            className={`mt-1 block w-full rounded-md border border-gray-300 focus:border-[#1B365D] focus:ring focus:ring-[#1B365D]/20 p-2 ${isEditing ? 'bg-white cursor-pointer' : 'bg-gray-100'}`}
                        />
                    </div>
                ))}
            </div>
{!['approved', 'drafted', 'completed'].includes(intermediario.report_status ?? '') && (

            <div className="flex justify-end space-x-4">
                {!isEditing ? (
                    (
                        <>
                            <button
                                onClick={handleModifica}
                                className="px-4 py-2 bg-[#1B365D] text-white hover:bg-[#142a4a] rounded-lg"
                            >
                                Modifica
                            </button>
                            <button
                                onClick={onClickValida}
                           disabled={isIntermediarioValidato}
                   className={`px-4 py-2 rounded 
            ${isIntermediarioValidato 
              ? 'bg-gray-200 text-gray-400 cursor-not-allowed' 
              : 'bg-textPrimary text-white hover:bg-textSecondary'}`
          }>
                                Valida
                            </button>
                        </>
                    )
                ) : (
                    <>
                        <button
                            onClick={handleAnnulla}
                            className="px-4 py-2 bg-gray-200 text-gray-800 hover:bg-gray-300 rounded"
                        >
                            Annulla
                        </button>
                        <button
                            onClick={handleSalva}
                            className="px-4 py-2 bg-[#1B365D] text-white hover:bg-[#142a4a] rounded-lg"
                        >
                            Salva
                        </button>
                    </>
                )}
 
                {showDialogConfermaValidazione && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
                        <div className="bg-white p-6 rounded shadow-lg max-w-sm w-full">
                            <ConfirmValidationDialog
                                onConferma={handleValidazione}
                                onAnnulla={() => setShowDialogConfermaValidazione(false)}
                            />
                        </div>
                    </div>
                )}
            </div>
)}
            {/* Inserisci qui la Legenda */}
            <div className="mt-6 p-4 border-t border-gray-100 text-sm text-[#1B365D]">
                <strong>Legenda:</strong>
                <ul className="list-disc ml-6 mt-2">
                    {transparencyClassesLegend.map(({ label, description }) => (
                        <li key={label}><strong>{label}:</strong> {description}</li>
                    ))}
                </ul>
            </div>
            
              {/* Note Dettaglio */}
            <div className="mt-8 ">
                <div className="bg-gray-50 p-6 rounded-xl border border-gray-100">
                    <h2 className="text-xl font-semibold text-[#1B365D] font-semibold mb-3">Riassunto informazione estratte</h2>
                    <ul className="list-none list-inside text-gray-700 leading-relaxed mb-6">
                        {intermediario.value?.summary_selected_information && (
                            <li>{cleanContent(intermediario.value.summary_selected_information)}</li>
                        )}
                    </ul>
                    <h2 className="text-xl font-semibold text-[#1B365D] font-semibold mb-3">Frasi rilevanti </h2>
                    <ul className="list-none list-inside text-gray-700 leading-relaxed mb-6">
                        {intermediario.value?.reasoning && (
                            <li>{cleanContent(intermediario.value.reasoning)}</li>
                        )}
                    </ul>
                    <h2 className="text-xl font-semibold text-[#1B365D] font-semibold mb-3">Analisi</h2>
                    <ul className="list-none list-inside text-gray-700 leading-relaxed mb-2">
                        {intermediario.value?.list_relevant_sentences?.map((frase, index) => (
                            <li className="mb-4" key={index}>{cleanContent(frase)}</li>
                        ))}
                    </ul>
                </div>
            </div>
            
            <SourcesAccordion sources={sources} reportId={id} componentId={driverId} elementId={intermediarioId} />
            {/* Sezione Attività */}
            <EventList events={events} />

        </div>
    );
};

export default ContainerTrasparenzaInformativaDettagli;